import { DataTable } from "../components/DataTable";
import { PipelineCards } from "../components/PipelineCards";

export function RequisitionsTab() {
  return (
    <div className="space-y-4">
      <PipelineCards />
      <DataTable table="requisitions" title="Requisitions" lens="req" />
    </div>
  );
}
